import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

/** Themawissel. Schrijft kb:theme (en migreert de oude kb-theme-sleutel weg);
 *  data-theme + color-scheme worden samen gestempeld zodat scrollbars,
 *  selects en autofill meeschakelen. */
export function ThemeToggle() {
  const [dark, setDark] = useState<boolean | null>(null);

  useEffect(() => {
    setDark(document.documentElement.getAttribute('data-theme') === 'dark');
  }, []);

  const toggle = () => {
    const next = !(document.documentElement.getAttribute('data-theme') === 'dark');
    const r = document.documentElement;
    r.setAttribute('data-theme', next ? 'dark' : 'light');
    r.style.colorScheme = next ? 'dark' : 'light';
    try {
      localStorage.setItem('kb:theme', next ? 'dark' : 'light');
      localStorage.removeItem('kb-theme'); // oude sleutel opruimen
    } catch { /* private mode */ }
    setDark(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Thema wisselen"
      title="Donker / licht"
      className="rounded-md p-2 text-ink-2 transition hover:bg-surface-hover hover:text-ink"
    >
      {/* vóór hydratatie neutraal — geen mismatch tussen server en client */}
      {dark === null ? <Sun size={17} className="opacity-0" /> : dark ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
}
